<img (error)="onError($event)" [src]="getImageUrl()" width="{{width}}" height="{{height}}" class="{{class}}" />